// Helper to build the canonical display name of a policy per user's spec:
//   [modification_date] TYPE YYYY/MM/DD Title [Rn]
// - modification_date prefix appears only when the policy has been modified
//   after being published (i.e. last_modified_at set + revision > 0).
// - Rn appears only when revision > 0.
// - For drafts (no published_at), we still show TYPE + title (no date, no R).

function toSlash(iso) {
    if (!iso) return "";
    return String(iso).slice(0, 10).replaceAll("-", "/");
}

export function policyDisplayName(p) {
    if (!p) return "";
    const tp = p.type || "";
    const pub = toSlash(p.published_at);
    const rev = Number(p.revision || 0);
    const mod = p.last_modified_at ? toSlash(p.last_modified_at) : "";
    const rSuffix = rev > 0 ? ` R${rev}` : "";
    const modPrefix = mod && rev > 0 ? `${mod} · ` : "";
    const dateSpan = pub ? ` ${pub}` : "";
    const titleSpan = p.title ? ` ${p.title}` : "";
    return `${modPrefix}${tp}${dateSpan}${titleSpan}${rSuffix}`.trim();
}

export function policySeriesLabel(p) {
    if (!p || !p.series || !p.series_number) return "";
    return `SERIE ${String(p.series).toUpperCase()} N. ${p.series_number}`;
}
